import { render } from "./SystemSettings.vue?vue&type=template&id=383cec93&scoped=true"
import script from "./SystemSettings.vue?vue&type=script&lang=js"
export * from "./SystemSettings.vue?vue&type=script&lang=js"

import "./SystemSettings.vue?vue&type=style&index=0&id=383cec93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383cec93"]])

export default __exports__